<template>
  <div>
    <ListPageDesktop v-if="isDesktopView" />
    <ListPageMobile v-if="isMobileView" />
  </div>
</template>

<script>
import sharedComputed from '@/methods/sharedComputed'
import sharedMethods from '@/methods/sharedMethods'

import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import ListPageDesktop from '@/components/Views/List/ListPageDesktop'
import ListPageMobile from '@/components/Views/List/ListPageMobile'
import _filters from '@/_filters'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ListPageContainer',

  metaInfo() {
    return this.getMetaTags()
  },

  components: {
    ListPageMobile,
    ListPageDesktop,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    routeQuery() {
      return JSON.stringify(this.$route.query)
    },

    routePath() {
      return JSON.stringify(this.$route.fullPath)
    },

    matchingArticle() {
      const searchQuery = this.routePath.replace(/"/g, '').split('/?').pop()
      let matchKey = ''
      Object.keys(this.pagesById).filter((key) => {
        const page = this.pagesById[key]
        if (page.listSearchQuery === searchQuery) {
          matchKey = key
        }
      })
      return matchKey ? this.pagesById[matchKey] : null
    },
  },

  watch: {
    routePath() {
      this.setListMeta()
    },

    routeQuery() {
      this.$nextTick(() => {
        if (!this.progressSearching) {
          this.parseSearchFiltersFromQuery()
          this.searchObjects()
        }
      })
    },
  },

  created() {
    this.setListMeta()
    this.setContentAreaWidth()
    this.parseSearchFiltersFromQuery()
    if (
      this.filtersHash &&
      this.filtersHash === _filters.getHash(this.$store.state)
    ) {
      return
    }
    if (!this.progressSearching) {
      this.progressSearching = true
      this.$store.dispatch('findObjects').then(() => {
        this.progressSearching = false
        this.$nextTick(() => {
          this.scrollToBeginningOfListResult()
        })
      })
    }
  },

  methods: {
    ...sharedMethods,

    setListMeta() {
      this.metaTitle = this.metaSiteName
      this.metaUrl = this.defaultMetaUrl
      this.metaDescription = this.defaultMetaDescription
      this.metaImage = this.defaultMetaImage
      if (this.matchingArticle) {
        const m = this.matchingArticle
        if (m['metaDescription_' + this.lang]) {
          this.metaDescription = m['metaDescription_' + this.lang]
        }
        if (m['metaTitle_' + this.lang]) {
          this.metaTitle = m['metaTitle_' + this.lang]
        }
      }
    },
  },
}
</script>
